function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function VerticalCarousel(_ref) {
  var _ref$images = _ref.images,
    images = _ref$images === void 0 ? [] : _ref$images,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options;
  var containerRef = useRef(null);
  var firstImgRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    ratio = _useState2[0],
    setRatio = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMobile = _useState6[0],
    setIsMobile = _useState6[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      setIsMobile(window.innerWidth < 768);
    };
    // Set initial value
    handleResize();
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Clean up
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  var _useEmblaCarousel = useEmblaCarousel(_objectSpread({
      axis: 'y',
      loop: true,
      align: 'start',
      duration: 24,
      skipSnaps: false
    }, options)),
    _useEmblaCarousel2 = _slicedToArray(_useEmblaCarousel, 2),
    viewportRef = _useEmblaCarousel2[0],
    emblaApi = _useEmblaCarousel2[1];
  useEffect(function () {
    var img = firstImgRef.current;
    if (!img) return;
    var handleLoad = function handleLoad() {
      if (img.naturalWidth && img.naturalHeight) {
        var r = img.naturalHeight / img.naturalWidth;
        setRatio(r);
      }
    };
    if (img.complete) {
      handleLoad();
    } else {
      img.onload = handleLoad;
    }
  }, [images, isMobile]);
  useEffect(function () {
    if (!containerRef.current || !ratio) return;
    var updateHeight = function updateHeight() {
      var width = containerRef.current.clientWidth;
      setHeight(width * ratio);
    };
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return function () {
      return window.removeEventListener('resize', updateHeight);
    };
  }, [ratio]);
  var scrollNext = function scrollNext() {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  };
  useEffect(function () {
    if (!emblaApi) return;
    var AUTOPLAY_DELAY = 3000; // 3s, adjust as you like

    var id = setInterval(function () {
      emblaApi.scrollNext();
    }, AUTOPLAY_DELAY);

    // cleanup on unmount or when emblaApi changes
    return function () {
      return clearInterval(id);
    };
  }, [emblaApi]);
  return /*#__PURE__*/_jsxs("div", {
    ref: containerRef,
    className: "relative w-full",
    style: height ? {
      height: height
    } : undefined,
    children: [/*#__PURE__*/_jsx("div", {
      ref: viewportRef,
      className: "overflow-hidden rounded-xl w-full h-full",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex flex-col w-full h-full",
        children: images.map(function (src, index) {
          return /*#__PURE__*/_jsx("div", {
            className: "flex-none w-full h-full flex items-center justify-center",
            children: /*#__PURE__*/_jsx("img", {
              ref: index === 0 ? firstImgRef : null,
              src: isMobile ? src.mobile : src.desktop,
              alt: "Slide ".concat(index + 1),
              className: "w-full h-full rounded-xl object-cover"
            })
          }, index);
        })
      })
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: scrollNext,
      className: "absolute bottom-4 left-1/2 -translate-x-1/2 inline-flex items-center justify-center h-9 w-9 rounded-full text-white text-lg transition border-[2px] border-white",
      children: /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        className: "w-5",
        children: /*#__PURE__*/_jsx("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "m19.5 8.25-7.5 7.5-7.5-7.5"
        })
      })
    })]
  });
}